<template>
  <v-form
    id='order-conclusion-form'
    @submit.prevent='submitForm'
  >
    <v-row  v-if = !this.hide_time_estimate>
      <v-col cols="11">
        <div class='custom-pl-36'>
          <p class="font-weight-bold">{{ $t('order.attributes.times_title') }}</p>
          <div class="v-text-field__details"><div class="v-messages theme--light"><div class="v-messages__wrapper"><div class="v-messages__message"> {{ $t('order.attributes.times_title_hint') }} </div></div></div></div>
        </div>
      </v-col>

      <time-picker-select
        custom_label="Check-in"
        class="custom-pl"
        :time_default = "checkin_time_estimate"
        :min = "checkin_time_from"
        :max = "checkin_time_to"
        :step = 15
        :required = "time_estimate_mandatory"
        @callback_on_change_time='updateCheckin'
        :error_msg = "checkinTimeEstimateErrors"
      />
      <time-picker-select
        class="pl-10"
        custom_label="Check-out"
        :time_default = "checkout_time_estimate"
        min = "00:00"
        :max = "checkout_time_until"
        :step = 15
        :required = "time_estimate_mandatory"
        @callback_on_change_time='updateCheckout'
        :error_msg = "checkinTimeEstimateErrors"
      />
      <v-col v-if = "!smart_door" cols="12" class="custom-pl">
        <div v-if ="apartment.rule_key[$i18n.locale]">
          <p class="font-weight-bold">{{ $t('order.attributes.instruction_pick_up_keys') }}</p>
          <span v-html="apartment.rule_key[$i18n.locale]"></span>
        </div>
        <div v-if ="apartment.rule_checkin[$i18n.locale] ">
          <p class="font-weight-bold">{{ $t('order.attributes.instruction_checkin') }}</p>
          <span v-html="apartment.rule_checkin[$i18n.locale]"></span>
        </div>
      </v-col>
      <v-col v-else cols="12" class="custom-pl">
        <p class="font-weight-bold">{{ $t('order.attributes.instruction_checkin') }}</p>
        {{ $t('order.attributes.instruction_checkin_smart_door', {checkin_time_from: checkin_time_from, checkout_time_until: checkout_time_until}) }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12'>
        <p class=" custom-pl-36 font-weight-bold">
          {{ $t('order.attributes.title_note') }}
        </p>
        <v-textarea
          v-model='client_note'
          :error-messages='clientNoteErrors'
          persistent-hint
          :hint="$t('order.hints.client_note')"
          @blur='updateClientNote'
          prepend-icon='mdi-pen'
          auto-grow
          outlined
        >
          <template v-slot:append>
            <v-fade-transition leave-absolute group>
              <v-progress-circular
                key='progress'
                v-if="isSubmittingClientNote"
                size="24"
                color="info"
                indeterminate
              />
              <div v-else key='result'>
                <v-icon key='updated' v-if='updatedClientNote' color="success">mdi-check-bold</v-icon>
                <v-icon key='not-updated' v-if='updatedClientNote == false' color="error">mdi-alert-circle-outline</v-icon>
              </div>
            </v-fade-transition>
          </template>
        </v-textarea>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="4" lg="3">
        <v-radio-group
          v-model='trip_category'
          class='ml-8 standard_style'
          :loading="isSubmittingTripCategory"
          :error-messages='tripCategoryErrors'
          @change="updateTripCategory"
        >
          <p class="font-weight-bold required">
            {{ $t('order.attributes.trip_category') }}
          </p>
          <v-radio :label='$t("order.attributes.trip_categories.leisure")' value='LEISURE'/>
          <v-radio :label='$t("order.attributes.trip_categories.business")' value='BUSINESS'/>
          <v-radio :label='$t("order.attributes.trip_categories.family")' value='FAMILY'/>
          <v-radio :label='$t("order.attributes.trip_categories.medical")' value='MEDICAL'/>
        </v-radio-group>
      </v-col>
    </v-row>


  </v-form>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { validationMixin } from 'vuelidate'
  import { required, requiredIf } from 'vuelidate/lib/validators'
  import TimePickerSelect from '../checkin/time_picker_select'
  import { apartmentMixin } from '../../mixins/apartment_mixin'
  import { orderMethodsMixin} from '../../mixins/order_methods_mixin'
  import { utilityMixin } from '../../mixins/utility_mixin'

  export default {
    name: 'OrderConclusionForm',
    components: {
      TimePickerSelect
    },
    mixins: [
      validationMixin,
      apartmentMixin,
      orderMethodsMixin,
      utilityMixin,
    ],
    props: {
      order: {
        type: Object,
        required: true,
      },
      reservation: {
        type: Object,
        required: true,
      },
    },
    validations() {
      return {
        trip_category:          { required },
        checkin_time_estimate:  (!this.hide_time_estimate && this.time_estimate_mandatory) ? { required } : { required: false },
        checkout_time_estimate: (!this.hide_time_estimate && this.time_estimate_mandatory) ? { required } : { required: false },
        client_note:            { required: false },
      }
    },
    data() {
      return {
        checkin_time_estimate: null,
        checkout_time_estimate: null,
        checkin_time_from: null,
        checkin_time_to: null,
        checkout_time_until: null,
        hide_time_estimate: false,
        time_estimate_mandatory: false,
        smart_door: false,
        trip_category: null,
        client_note: null,
        checkin_location: null,
        checkinTimeEstimatePickerOpened: false,
        serverSideErrors: {},
        isSubmittingTripCategory: false,
        updatedTripCategory: null,
        isSubmittingClientNote: false,
        updatedClientNote: null,
        isSubmittingCheckinTimeEstimate: false,
        updatedCheckinTimeEstimate: null,
        isSubmittingCheckinLocation: false,
        updatedCheckinLocation: null,
        //  Map handler
        map: null,
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        //optional: offset infowindow so it visually sits nicely on top of our marker
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        //  Map handler End
      }
    },
    created() {
      this.trip_category         = this.order.customer.category || this.currentUser.category
      this.checkin_time_estimate = this.formattedTime(this.reservation.checkin_time_est)
      this.checkout_time_estimate = this.formattedTime(this.reservation.checkout_time_est)
      this.client_note           = this.order.client_note
      this.checkin_location      = this.reservation.checkin_location
      this.checkin_time_from     = this.formattedTime(this.apartment.checkin_from)
      this.checkin_time_to       = this.formattedTime(this.apartment.checkin_to)
      this.checkout_time_until   = this.formattedTime(this.apartment.checkout_until)
      this.hide_time_estimate    = this.apartment.hide_time_estimate
      this.time_estimate_mandatory   = this.apartment.time_estimate_mandatory
      this.smart_door   = this.apartment.smart_door

      if ((this.trip_category && (this.hide_time_estimate || !this.time_estimate_mandatory)) ||(this.trip_category && (!this.hide_time_estimate && this.time_estimate_mandatory && this.checkin_time_estimate && this.checkout_time_estimate))){
        this.$emit('form:completed',true)
      }
    },
    computed: {
      ...mapState('layout', ['submitting']),
      ...mapGetters('profile', ['currentUser']),
      selectedLocation() {
        return !!this.checkin_location ? this.markers.find(marker => marker.name == this.checkin_location ) : null
      },
      markers() {
        return [
          {
            name: this.apartment_reception.name,
            label: this.$t("order.attributes.checkin_locations.reception"),
            description: this.apartment_reception.name,
            address: this.apartment_reception_place,
            position: {lat: parseFloat(this.apartment_reception.latitude), lng: parseFloat(this.apartment_reception.longitude)},
          },
          {
            name: 'Appartamento',
            label: this.$t("order.attributes.checkin_locations.apartment"),
            description: this.apartment.name,
            address: this.apartment_place,
            position: {lat: parseFloat(this.apartment.lat), lng: parseFloat(this.apartment.lng)},
          },
        ]
      },
      tripCategoryErrors() {
        const errors = []
        if (!this.$v.trip_category || !this.$v.trip_category.$dirty) return errors
        !!this.serverSideErrors.trip_category && errors.push(this.serverSideErrors.trip_category.join(' - '))
        !this.$v.trip_category.required && errors.push(this.$t('errors.required'))
        return errors
      },
      checkinTimeEstimateErrors() {
        const errors = []
        if (!this.$v.checkin_time_estimate || !this.$v.checkin_time_estimate.$dirty) return errors
        !!this.serverSideErrors.checkin_time_estimate && errors.push(this.serverSideErrors.checkin_time_estimate.join(' - '))
        !this.$v.checkin_time_estimate.required && errors.push(this.$t('errors.required'))
        return errors
      },
      checkoutTimeEstimateErrors() {
        const errors = []
        if (!this.$v.checkout_time_estimate || !this.$v.checkout_time_estimate.$dirty) return errors
        !!this.serverSideErrors.checkout_time_estimate && errors.push(this.serverSideErrors.checkout_time_estimate.join(' - '))
        !this.$v.checkout_time_estimate.required && errors.push(this.$t('errors.required'))
        return errors
      },
      clientNoteErrors() {
        const errors = []
        if (!this.$v.client_note || !this.$v.client_note.$dirty) return errors
        !!this.serverSideErrors.client_note && errors.push(this.serverSideErrors.client_note.join(' - '))
        !this.$v.client_note.required && errors.push(this.$t('errors.required'))
        return errors
      },
      checkinLocationErrors() {
        const errors = []
        if (!this.$v.checkin_location || !this.$v.checkin_location.$dirty) return errors
        !!this.serverSideErrors.checkin_location && errors.push(this.serverSideErrors.checkin_location.join(' - '))
        !this.$v.checkin_location.required && errors.push(this.$t('errors.required'))
        return errors
      },

    },
    methods: {
      // Gmap handlers
      toggleInfoWindow: function (marker, idx) {
        this.infoWindowPos = marker.position;
        this.infoContent = this.getInfoWindowContent(marker);


        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },
      getInfoWindowContent: function (marker) {
        return (`<div class="card">
  <div class="card-content">
    <div class="media">
      <div class="media-content">
        <p class="title is-4">${marker.label}</p>
      </div>
    </div>
    <div class="content">
      ${marker.address}
    </div>
  </div>
</div>`);
      },
      updateTripCategory() {
        this.$v.trip_category.$touch()
        this.isSubmittingTripCategory = true
        this.callConclusionApi({trip_category: this.trip_category})
          .then( _ => {
            this.serverSideErrors.trip_category = null
            let user = {}
            Object.assign(user, this.currentUser)
            user.category = this.trip_category
            this.$store.commit('profile/SET_USER', user)
          })
          .catch(error => {
            this.serverSideErrors.trip_category = [error.body ? error.body.error : error]
          })
          .finally(_ => {
            this.isSubmittingTripCategory = false
            this.isFormCompleted()
          })
      },
      updateCheckinTime() {
        this.$v.checkin_time_estimate.$touch()
        this.callConclusionApi({checkin_time_estimate: this.checkin_time_estimate})
           .then( _ => {
              this.serverSideErrors.checkin_time_estimate = null
           })
           .catch(error => {
           this.serverSideErrors.checkin_time_estimate = [error.body ? error.body.error : error]
         }).finally(_ => (this.isFormCompleted()))
      },
      updateCheckoutTime() {
        this.$v.checkout_time_estimate.$touch()
        this.callConclusionApi({checkout_time_estimate: this.checkout_time_estimate})
          .then( _ => {
            this.serverSideErrors.checkout_time_estimate = null
          })
          .catch(error => {
            this.serverSideErrors.checkout_time_estimate = [error.body ? error.body.error : error]
          }).finally(_ => (this.isFormCompleted()))
      },
      updateClientNote() {
        this.$v.client_note.$touch()
        this.isSubmittingClientNote = true
        this.callConclusionApi({client_note: this.client_note})
          .then( _ => {
            this.serverSideErrors.client_note = null
            this.updatedClientNote = true
          })
          .catch(error => {
            this.serverSideErrors.client_note = [error.body ? error.body.error : error]
            this.updatedClientNote = false
          })
          .finally(_ => {
            this.isFormCompleted()
            this.isSubmittingClientNote = false
          })
      },
      updateCheckin(result){
        this.checkin_time_estimate = result
        this.updateCheckinTime()
      },
      updateCheckout(result){
        this.checkout_time_estimate = result
        this.updateCheckoutTime()
      },
      isFormCompleted() {

        if (!this.$v.$invalid
            && (this.hide_time_estimate || (this.checkoutTimeEstimateErrors.length == 0 && this.checkinTimeEstimateErrors.length == 0 ))
            && this.tripCategoryErrors.length == 0){
          this.$emit('form:completed',true)
        }
      },
    },
  }
</script>
<style>
  div.custom-pl, p.custom-pl{
    padding-left: 48px;
  }
  div.custom-pl-36, p.custom-pl-36{
    padding-left: 36px;
  }
  #order-conclusion-form p{
    margin-bottom: 0px;
  }
  div.padding_top_0{
    padding-top: 0px;
  }
  div.theme--light.v-input.standard_style{
    margin-top: 0;
    padding-top: 0;
  }
  div.theme--light.v-input.standard_style,
  div.theme--light.v-input.standard_style label.v-label{
    color: rgba(0, 0, 0, .6);
    font-size: 14px;
  }
  .required::before{
    content: '*';
    color: red;
    font-size: 13px;
  }

</style>
